import { Button, Checkbox, Divider, Heading, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Icon, IconButton, Input, Menu, MenuButton, MenuItem, MenuList, Radio, RadioGroup, SimpleGrid, Stack, Table, TableContainer, Tbody, Td, Text, useToast, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { BsChevronDown } from "react-icons/bs";
import { useEffect, useRef, useState } from "react";
import DocViewer, { DocViewerRef, DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { FaArrowLeft, FaArrowRight, FaCheck, FaFileExcel, FaFileInvoice, FaHistory, FaSave } from "react-icons/fa";
import { RiContactsBookFill } from "react-icons/ri";

import { GET, GETFile, PUT } from "../../../utils/ApiRequestProvider";
import Cookies from "js-cookie";
import { useParams } from 'react-router';


import { BASE_URL } from "config";

interface PaginationType {
    currentPage: number;
    totalPages: number;
    totalRecords: number;
}

interface FileViewerType {
    documentId: number;
    uri: string;
    fileName: string;
}

interface CompanyInfo {
    Name: string;
    Industry: string;
    Country: string;
    Credit: string;
    Software: string;
    Duplicate: string;
    VAT: string;
    VATScheme: string;
    SubscriptionStatus: string;
    SubscriptionPlan: string;
    ProcessingStatus: string;
    DataEntryBy: number;
    DataEntryTime: string;
    ReviewBy: number;
    ReviewTime: string;
    Source: string;
    baseCurrency: string;
}

const initialCompanyInfo: CompanyInfo = {
    Name: '',
    Industry: '',
    Country: '',
    Credit: '',
    Software: '',
    Duplicate: '',
    VAT: '',
    VATScheme: '',
    SubscriptionStatus: '',
    SubscriptionPlan: '',
    ProcessingStatus: '',
    DataEntryBy: 0,
    DataEntryTime: '',
    ReviewBy: 0,
    ReviewTime: '',
    Source: '',
    baseCurrency: '',
}

interface FileData {
    name: string;
    uploadedBy: string;
    uploadedAt: string;
}

const initialFileData: FileData = {  
    name: '',
    uploadedBy: '',
    uploadedAt: '',
}

type urlParams = {
    id: string;
}

export default function OtherDocuments() {
    const { id } = useParams<urlParams>();
        const [paginationQuery] = useState({ page: 1, pageSize: 10 });
    const [companyInfo, setCompanyInfo] = useState<CompanyInfo>(initialCompanyInfo);
    const [, setPagination] = useState<PaginationType>({ currentPage: 0, totalPages: 0, totalRecords: 0 });
    const [, setLoading] = useState(false);
    const toast = useToast();
    const [documents, setDocuments] = useState<any[]>([]);
    const [selectedDocuments, setSelectedDocuments] = useState<Array<any>>([]);
    const [selectedDocument, setSelectedDocument] = useState<any>({});
    const [selectedDocumentPDF, setSelectedDocumentPDF] = useState<FileViewerType[]>([]);
    const docViewerRef = useRef<DocViewerRef>(null);
    const fileRef = useRef<HTMLInputElement>(null);
    const formRef = useRef<HTMLFormElement>(null);
    const [Doc, setDoc] = useState<string>('PurchaseInvoice');
    const [History, setHistory] = useState<any[]>([]);
    const [FileDataInfo, setFileData] = useState<FileData>(initialFileData);
    const { isOpen: isOpenHistory, onOpen: onOpenHistory, onClose: onCloseHistory } = useDisclosure();
    const [extractedText, setExtractedText] = useState<string>('');
    let user = JSON.parse(localStorage.getItem("user") ?? (Cookies.get("user") ?? "{}"));
    let role = user.role;

    async function runGetRequest(handleData: (data: any) => void, url: string) {
        setLoading(true);
        try {
            let res = await GET(url);
            if (res.status === 'success' && (
                (Array.isArray(res.data) && res.data.length > 0)
                || (Object.keys(res.data) && Object.keys(res.data).length > 0))
            ) {
                const { data } = res;
                
                handleData(data);
            }
        } catch (err) {
            // console.log(err)
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occurred while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
        setLoading(false);
    }

    async function getDocuments() {
        const stat = role === "supervisor" ? "&status=Review" : "&status=Uploaded";
        runGetRequest((data: any) => {
            
            const { docs: [{ documents, ...companyInfo }], pagination } = data;
            setPagination(pagination);
            setDocuments(documents);
            setCompanyInfo(companyInfo);
        }, `/api/Documents/${id}/OtherDocuments/InvoiceList?page=${paginationQuery.page}&pageSize=${paginationQuery.pageSize}${stat}&sortColumn=Date&sortOrder=desc`);
    }

    const convertDate = (date: string) => {
        const datehistory = new Date(date).toUTCString()
        return datehistory;
    }

    const handleSelectedDocument = async (e: any) => {
        if (e.target.checked) {
            // console.log(e.target.id);
            const id = parseInt(e.target.id);
            setSelectedDocuments([...selectedDocuments, e.target.id]);
            // console.log(documents.filter(doc => doc.id === id));
            setSelectedDocument(documents.filter(doc => doc.documentId === id));
        } else {
            setSelectedDocuments(selectedDocuments.filter((doc) => doc.documentId !== e.target.id));
            setSelectedDocument({});
        }
    }

    const getFilePDF = async () => {
        try {
            if(selectedDocument[0]?.file === undefined || selectedDocument[0]?.file === null){
                setSelectedDocumentPDF([]);
                return;
            }
            if(selectedDocumentPDF.find(doc => doc.documentId === selectedDocument[0]?.id) !== undefined){
                return;
            }
            const file = await GETFile(selectedDocument[0]?.file);
            setSelectedDocumentPDF([...selectedDocumentPDF, { documentId: selectedDocument[0]?.id, uri: URL.createObjectURL(file), fileName: file.name }]);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    const handleChangeDoc = (value: string) => {
        setDoc(value);
    }

    const handleExtractedText = async () => {
        if(selectedDocument.length === 0 || selectedDocument.length === undefined){
            toast({
                title: 'No Document Selected!',
                description: 'Please select a document to save extracted text!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        if(extractedText === ''){
            toast({
                title: 'No Text Found!',
                description: 'Please enter some text to save!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        // const formData = new FormData(formRef.current ?? new HTMLFormElement());
        // console.log(user);
        const stat = role === "supervisor" ? "processed" : "save";
        const array_to_send = {"dataEntryOperatorId": user.id ,"extractedText": extractedText,"isSave": true};
            const response = await PUT(`/api/Documents/${stat}/${selectedDocuments[0]}`, array_to_send);
            if (response.status === 'success') {
                toast({
                    status: "success",
                    title: "File Uploaded!",
                    description: "File has been uploaded successfully!",
                    duration: 1000,
                    position: "top-right"
                });
            } else {
                toast({
                    status: "error",
                    title: "Error!",
                    description: "An unexpected error occurred while proceeding your request!",
                    duration: 1000,
                    position: "top-right"
                });
            }
        
    }

    const saveExcel = async () => {
        setLoading(true);
        const fileInput = fileRef.current;

        if (fileInput && fileInput.files && fileInput.files.length > 0) {
            const formData = new FormData(formRef.current ?? new HTMLFormElement());
            const response = await PUT(`/api/Documents/attachDoc/${selectedDocuments[0]}`, formData);
            if (response.status === 'success') {
                toast({
                    status: "success",
                    title: "File Uploaded!",
                    description: "File has been uploaded successfully!",
                    duration: 1000,
                    position: "top-right"
                });
            } else {
                toast({
                    status: "error",
                    title: "Error!",
                    description: "An unexpected error occurred while proceeding your request!",
                    duration: 1000,
                    position: "top-right"
                });
            }
            setLoading(false);
        } else {
            toast({
                status: "error",
                title: "No Files Selected!",
                description: "Please upload some file first!",
                duration: 1000,
                position: "top-right"
            });
        }
        
    }

    const handleReClassify = async () => {
        console.log(selectedDocument.length);
        if(selectedDocument.length === 0 || selectedDocument.length === undefined){
            toast({
                title: 'No Document Selected!',
                description: 'Please select a document to reclassify!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
            
        if(window.confirm('Are you sure to Reclassify this document?')){
            var arr_ids : any[] = [];
            selectedDocuments.forEach((item) =>{
                arr_ids.push(item);
            });
            var arr_to_reclassify = {"documents_Id": arr_ids, "doctype": Doc};
            const response = await PUT(`/api/documents/reclassify`, arr_to_reclassify);
            if(response.status === "success"){
                toast({
                    title: 'Document Reclassified!',
                    description: 'Document has been reclassified successfully!',
                    status: 'success',
                    isClosable: false,
                    duration: 1000,
                    position: 'top-right'
                });
                getDocuments();
            }
        }
    }

    function onFileChange() {
        setLoading(true);
        if (fileRef.current?.files?.length !== undefined) {
            if (fileRef.current.files.length === 0) return toast({
                status: "error",
                title: "No Files Selected!",
                description: "Please upload some files first!",
                duration: 1000,
                position: "top-right"
            });
            console.log(fileRef.current?.files[0].name);
            const name = fileRef.current?.files[0].name;
            const uploadedAt = new Date().toUTCString();
            const uploadedBy = user.fullName;
            setFileData({ name, uploadedBy, uploadedAt });
            
        }
        setLoading(false);
    }

    async function GetHistory(){
        if(selectedDocument.length === 0 || selectedDocument.length === undefined){
            toast({
                title: 'No Document Selected!',
                description: 'Please select a document to view history!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }

        const response = await GET(`api/Documents/getDocumentHistory?doc=${selectedDocuments[0]}`);
        if(response.status === 'success'){
            if(response.data.length > 0){
                setHistory(response.data)
                onOpenHistory();
            }else{
                toast({
                    title: 'Error!',
                    description: 'No history found for this document',
                    status: 'error',
                    isClosable: true,
                    duration: 1000,
                    position: 'top-right'
                });
            } 
        }
    }

    const ProcessDocument = async () => {
        if(selectedDocuments.length === 0 || selectedDocuments.length === undefined){
            toast({
                title: 'No Document Selected!',
                description: 'Please select a document to process!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        const stat = role === "supervisor" ? "Data Entered" : "Review";
        const response = await PUT(`/api/documents/reAssign/${selectedDocuments[0]}?status=${stat}`,{});
        if(response.status === "success"){
            toast({
                title: 'Document Processed!',
                description: 'Document has been processed successfully!',
                status: 'success',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
        getDocuments();
    }

    const DownloadFile = async () => {
        if(selectedDocument.length === 0 || selectedDocument.length === undefined){
            toast({
                title: 'No Document Selected!',
                description: 'Please select a document to download!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        // const response = await GET(`/api/Documents/exportDocument?doc=${selectedDocuments[0]}`);
        if(selectedDocument[0].dataFile === ""){
            toast({
                title: 'No File Found!',
                description: 'No file found for this document!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        const urlFile = BASE_URL + `/api/Documents/exportDocument?doc=${selectedDocuments[0].dataFile}`;
        console.log(urlFile);
        const blob = await fetch(urlFile).then(r => r.blob());
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', selectedDocument[0].dataFile.split('/')[selectedDocument[0].dataFile.split('/').length - 1]);
        document.body.appendChild(link);
        link.click();
    }

    

    useEffect(() => {
        console.log(selectedDocument);
        let name_file = '';
        // debugger;
        if(selectedDocument.length > 0){
            if(selectedDocument[0].dataFile !== ""){
                name_file = selectedDocument[0].dataFile.split('/');
                name_file = name_file[name_file.length - 1];
                setFileData({ name: name_file, uploadedBy: selectedDocument[0].uploadedBy.fullName, uploadedAt: convertDate(selectedDocument[0].uploadedDate) });
            }
        }else{
            setFileData({ name: '', uploadedBy: '', uploadedAt: '' });
        }
        getFilePDF();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDocument]);

    useEffect(()=>{
        // console.log(companyInfo);
    },[companyInfo])

    useEffect(() => {
        getDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Modal
                isCentered
                size={'6xl'}
                isOpen={isOpenHistory}
                onClose={onCloseHistory}
            >
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px)'
                />
                <ModalContent>
                    <ModalHeader
                        as={Stack}
                        direction={'row'}
                        borderBottom={'2px'}
                        borderBottomColor={'gray.300'}
                    >
                        <Icon
                            as={RiContactsBookFill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>History</Heading>
                        </Stack>
                    </ModalHeader>
                    <ModalBody as={Stack} direction={'row'} spacing={4} py={8}>
                        <Stack w={'full'}>
                            <Table>
                                <Thead>
                                    <Th>Document Id</Th>
                                    <Th>User</Th>
                                    <Th>Document Status</Th>
                                    <Th>Processed Time</Th>
                                    <Th>Email</Th>
                                </Thead>
                                <Tbody>
                                    {
                                        History.length > 0 ? History.map((item: any) => (
                                            <Tr>
                                                <Td>{item.documentId}</Td>
                                                <Td>{item.actionByEmail.split('@')[0]}</Td>
                                                {/* <Td>{item.documentType}</Td> */}
                                                <Td>{item.status}</Td>
                                                {/* <Td>{item.processedBy}</Td> */}
                                                <Td>{convertDate(item.createdAt)}</Td>
                                                <Td>{item.actionByEmail}</Td>
                                            </Tr>
                                        )) : 
                                        <Tr>
                                            <Td colSpan={5}>
                                                <Text w={'full'} textAlign={'center'}>No History Found</Text>
                                            </Td>
                                        </Tr>
                                    }
                                </Tbody>
                            </Table>
                        </Stack>
                    </ModalBody>
                    <ModalFooter
                        as={Stack}
                        direction={'row'}
                        spacing={4}
                        borderTop={'2px'}
                        borderTopColor={'gray.300'}
                    >
                        <Button
                            w={'full'}
                            onClick={onCloseHistory}
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'column', "2xl": "row" }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 6, "2xl": 0 }}
            >
                <Stack
                    align={'start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'} justify={'start'} align={'center'}>
                        <Icon
                            as={FaFileInvoice}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Other Documents</Heading>
                            <SimpleGrid templateColumns={'1fr 1fr 1fr'}>
                                <Text>Name: <strong>{companyInfo?.Name}</strong></Text>
                                <Text>Industry: <strong>{companyInfo?.Industry}</strong></Text>
                                <Text>Country: <strong>{companyInfo?.Country}</strong></Text>
                                <Text>Credit: <strong>{companyInfo?.Credit}</strong></Text>
                                <Text>Software: <strong>{companyInfo?.Software}</strong></Text>
                                <Text>Duplicate: <strong>{companyInfo?.Duplicate}</strong></Text>
                                <Text>VAT: <strong>{companyInfo?.VAT}</strong></Text>
                                <Text>VAT Scheme: <strong>{companyInfo?.VATScheme}</strong></Text>
                                <Text>Subscription Status: <strong>{companyInfo?.SubscriptionStatus}</strong></Text>
                                <Text>Subscription Plan: <strong>{companyInfo?.Software}</strong></Text>
                                <Text>Processing Status: <strong>{companyInfo?.ProcessingStatus}</strong></Text>
                                <Text>Data Entry By: <strong>{companyInfo?.DataEntryBy}</strong></Text>
                                <Text>Data Entry Time: <strong>{companyInfo?.DataEntryTime}</strong></Text>
                                <Text>Review By: <strong>{companyInfo?.ReviewBy}</strong></Text>
                                <Text>Review Time: <strong>{companyInfo?.ReviewTime}</strong></Text>
                                <Text>Source: <strong>{companyInfo?.Source}</strong></Text>
                            </SimpleGrid>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', "2xl": 'flex-end' }} direction={'row'} spacing={4}>
                    <Button
                        size={'sm'}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        AWS OCR
                    </Button>

                    <Menu>
                        <MenuButton
                            as={Button}
                            size={'sm'}
                            colorScheme={'red'}
                            rightIcon={<BsChevronDown />}
                        >
                            Delete
                        </MenuButton>
                        <MenuList>
                            <MenuItem>Absurd Document</MenuItem>
                            <MenuItem>Some other reason</MenuItem>
                        </MenuList>
                    </Menu>

                    <Button
                        size={'sm'}
                        // leftIcon={<FaHistory />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                        onClick={ProcessDocument}
                    >
                        Process
                    </Button>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <SimpleGrid
                    templateColumns={{ base: '1fr', md: '1fr 3fr 3fr' }}
                    spacing={6}
                >
                    <Stack>
                        <Stack
                            direction={'row'}
                            w={'full'}
                            justify={'flex-end'}
                        >
                            <Stack
                                direction={'row'}
                            >
                                <IconButton
                                    size={'sm'}
                                    colorScheme={'orange'}
                                    aria-label='Refresh'
                                    rounded={'full'}
                                    icon={<FaArrowLeft />}
                                />

                                <IconButton
                                    size={'sm'}
                                    colorScheme={'orange'}
                                    aria-label='Refresh'
                                    rounded={'full'}
                                    icon={<FaArrowRight />}
                                />
                            </Stack>
                        </Stack>
                        <TableContainer>
                            <Table size='sm'>
                                <Thead h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                                    <Tr>
                                        <Th></Th>
                                        <Th color={'white'}>ID</Th>
                                        <Th color={'white'}>Source</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        documents.length > 0 ?
                                        documents.map((doc, index) => (
                                            <Tr key={index}>
                                                <Td display={'flex'} justifyContent={'space-between'}>
                                                    <Checkbox id={doc?.documentId} onChange={handleSelectedDocument} />
                                                </Td>
                                                <Td>
                                                    {doc?.documentId}
                                                </Td>
                                                <Td>{doc?.source}</Td>
                                            </Tr>
                                        )) :
                                        <Tr>
                                            <Td colSpan={2}>No data found</Td>
                                        </Tr>
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Stack>
                    <Stack>
                        <Stack w={'full'} h={'full'} align={'center'} justify={'center'} textAlign={'center'} bg={'gray.500'}>
                        {
                                selectedDocumentPDF.length > 0 ?
                                    <DocViewer
                                        ref={docViewerRef}
                                        pluginRenderers={DocViewerRenderers}
                                        documents={selectedDocumentPDF}
                                        config={{
                                            // header: {
                                            //     overrideComponent: DocumentHeader,
                                            // },
                                            csvDelimiter: ",",
                                            pdfZoom: {
                                                defaultZoom: 1.1,
                                                zoomJump: 0.2,
                                            },
                                            pdfVerticalScrollByDefault: true,
                                        }}
                                        style={{ overflowY: 'auto' }}
                                        theme={{
                                            primary: "#ffffffeb",
                                            secondary: "#ffffff",
                                            tertiary: "#05445d",
                                            textPrimary: "#000000",
                                            textSecondary: "#ffffff",
                                            textTertiary: "#ffffff",
                                        }}
                                    />
                                    : <>
                                        <Heading color={'white'}>Document Viewer</Heading>
                                        <Text color={'whiteAlpha.900'} padding={'0 10px'}>No Documents Selected! Select Any Document To Preview Here.</Text>
                                    </>
                            }
                            </Stack>
                    </Stack>
                    <Stack w={'full'} spacing={2} divider={<Divider />}>
                        <Stack
                            w={'full'}
                            justify={'flex-end'}
                            direction={'row'}
                        >
                            <Checkbox size={'sm'} colorScheme={'primary'}>
                                Checked for multiple documents, this is single document.
                            </Checkbox>
                        </Stack>
                        <Stack
                            w={'full'}
                            align={'center'}
                            direction={'row'}
                            justify={'flex-end'}
                        >
                            <RadioGroup size={'sm'} colorScheme={'primary'} onChange={handleChangeDoc} defaultValue={Doc}>
                                <Stack direction='row'>
                                    <Radio value='PurchaseInvoice'>Purchase Invoice</Radio>
                                    <Radio value='SalesInvoice'>SalesInvoice</Radio>
                                    <Radio value='BankStatement'>Bank Statement</Radio>
                                </Stack>
                            </RadioGroup>
                            <Button
                                size={'sm'}
                                color={'white'}
                                bg={'primary.400'}
                                leftIcon={<FaFileInvoice />}
                                _hover={{ bg: 'primary.500' }}
                                _active={{ bg: 'primary.600' }}
                                onClick={handleReClassify}
                            >
                                Reclassify
                            </Button>
                            <Button
                                size={'sm'}
                                color={'white'}
                                bg={'red.500'}
                                leftIcon={<FaHistory />}
                                _hover={{ bg: 'red.500' }}
                                _active={{ bg: 'red.600' }}
                                onClick={GetHistory}
                            >
                                History
                            </Button>
                        </Stack>

                        <Input
                            w={'full'}
                            type={'text'}
                            id={'extractedText'}
                            placeholder={'Extracted Text'}
                            value={extractedText}
                            onChange={(e) => setExtractedText(e.target.value)}
                        />
                        
                        <Stack
                            direction={'row'}
                            w={'full'}
                            justify={'space-between'}
                        >
                            <Button
                                size={'sm'}
                                leftIcon={<FaSave />}
                                color={'white'}
                                bg={'primary.400'}
                                _hover={{ bg: 'primary.400' }}
                                _active={{ bg: 'primary.400' }}
                                onClick={handleExtractedText}
                            >
                                Save
                            </Button>
                        </Stack>
                        <Stack spacing={4}>
                            <Heading fontSize={'lg'}>Document Properties</Heading>
                            <Text bg={'gray.100'} py={2} px={2}>Uploaded By: <strong>{selectedDocument.length > 0 && selectedDocument[0].user.fullName}</strong></Text>
                            <Text px={2}>Upload Date: <strong>{selectedDocument.length > 0 && convertDate(selectedDocument[0].createdAt)}</strong></Text>
                            <Stack
                                direction={'row'}
                                align={"center"}
                                bg={'gray.100'}
                                py={2}
                                px={2}
                            >
                                <Text>Pages:</Text>
                                <Input
                                    w={'xs'}
                                    type={'number'}
                                    textAlign={'end'}
                                    id={'pages'}
                                    defaultValue={1}
                                />
                            </Stack>
                            <Text px={2}>Reject Comments: <strong>{selectedDocument.length > 0 && selectedDocument[0].notes}</strong></Text>
                            <Stack
                                direction={'row'}
                                align={"center"}
                                bg={'gray.100'}
                                py={2}
                                px={2}
                                justify={'space-between'}
                            >
                                <form ref={formRef}>
                                    <input name="dataFile" onChange={onFileChange} type={"file"} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" multiple ref={fileRef} />
                                    <input type={'hidden'} name="documentType" value="OtherDocuments" />
                                    <input type={'hidden'} name="Notes" value="0" />
                                    <input type={'hidden'} name="Tags" value="" />
                                    <input type={'hidden'} name="dataEntryOperatorId" value={user.id} />
                                    <input type={'hidden'} name="isSave" value="true" />
                                    <input type={"hidden"} name="UplaodedBy" value={FileDataInfo.uploadedBy} />
                                    <input type={"hidden"} name="UplaodedDate" value={FileDataInfo.uploadedAt} />
                                </form>
                                <Button
                                    size={'sm'}
                                    color={'white'}
                                    bg={'blue.400'}
                                    leftIcon={<FaFileExcel />}
                                    _hover={{ bg: 'red.500' }}
                                    _active={{ bg: 'red.600' }}
                                    onClick={() => fileRef.current?.click()}
                                >
                                    Select File
                                </Button>
                            </Stack>
                            <Stack 
                                direction={'row'}
                                align={"center"}
                                px={2}
                                justify={'flex-end'} 
                                display={selectedDocument.length > 0 ? (selectedDocument[0].dataFile !== "" ? 'flex' : 'none')  : 'none'}
                                >
                                <Button
                                    size={'sm'}
                                    color={'white'}
                                    bg={'blue.400'}
                                    leftIcon={<FaCheck />}
                                    _hover={{ bg: 'red.500' }}
                                    _active={{ bg: 'red.600' }}
                                    onClick={DownloadFile}>Download File</Button>
                            </Stack>
                            <Stack
                                direction={'row'}
                                align={"center"}
                                px={2}
                                justify={'flex-end'}
                            >
                                <Button
                                    size={'sm'}
                                    color={'white'}
                                    bg={'blue.400'}
                                    leftIcon={<FaCheck />}
                                    _hover={{ bg: 'red.500' }}
                                    _active={{ bg: 'red.600' }}
                                    onClick={saveExcel}
                                >
                                    Save
                                </Button>
                            </Stack>
                            <Text bg={'gray.100'} py={2} px={2}>Filename: <strong>{FileDataInfo?.name}</strong></Text>
                            <Text px={2}>Uploaded By: <strong>{FileDataInfo?.uploadedBy}</strong></Text>
                            <Text bg={'gray.100'} py={2} px={2}>Upload Date: <strong>{FileDataInfo?.uploadedAt}</strong></Text>

                        </Stack>
                    </Stack>
                </SimpleGrid>
            </Stack>
        </Stack >
    )
}